import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import {Flex, Skeleton} from "antd";
import {CategoryListCard, CategoryListHeader} from "../../components";
import {CategoryListProps} from "../../models";
import {getProductCategoryList} from "../../../../shared";
import SubCategoryPopup from "../../components/subCategoryPopup/SubCategoryPopup";
import ProvinceCard from "../../../../shared/components/location/provinceCard/ProvinceCard";
import CitiesCard from "../../../../shared/components/location/citiesCard/CitiesCard";
import categories from "../../../../shared/assets/Categories";
import {useNavigate, useParams} from "react-router-dom";
import SubCategoryPopupCard from "../../components/subCategoryPopup/SubCategoryPopupCard";
import SubCategoryCard from "../../components/subCategoryPopup/SubCategoryCard";

const SubCategoryList = ({getProductCategoryList}:CategoryListProps ) => {
    const { categoryId } = useParams();
   const navigate = useNavigate();

    const [open, setOpen] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false);
    const [subCategoryId, setSubCategoryId] = useState<number>();
    const onCansel = () => {
        setOpen(false)
    }
    // const getList = () => {
    //     setLoading(true);
    //     getProductCategoryList()
    //         .then((data: any) => {
    //             setLoading(false)
    //             if (data.payload != undefined) {
    //
    //                 setdataSourceWithIndex(data.payload.data);
    //
    //                 setLoading(false);
    //             } else {
    //                 setLoading(false);
    //             }
    //         })
    //         .catch((e: any) => {
    //         });
    // };
    // useEffect(() => {
    //     getList();
    // }, []);
    const category = categories.find(c => c.categoryId === Number(categoryId));
    const subCategories = category?.subCategories || [];
    return (
        <Flex vertical gap={"small"}>
            <CategoryListHeader/>
            {loading ?<Flex vertical >
                    <Skeleton round active/>
                    <Skeleton round active/>
                    <Skeleton round active/>
                </Flex> :
                subCategories.map((item:any) =>
                    <SubCategoryCard data={item}  onCategoryClick={(id:number) =>{
                        if (item.subSubCategories && item.subSubCategories.length > 0) {
                            setSubCategoryId(id)
                            setOpen(true)
                        } else {
                            navigate("/product-list/"+categoryId+"/"+id , {state : {subCategoryTitle : item.name}})
                        }

                    }}/>
                )
            }

            {open && <SubCategoryPopup subCategoryId={subCategoryId} open={open}
                                       onCansel={onCansel} onSubCategoryClick={(title: string) => {
                onCansel()
            }}/>}

        </Flex>
    );
};

export default connect(null, {getProductCategoryList})(withRouter(SubCategoryList));
